import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 48, className, ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    {...rest}
  >
    {children}
  </motion.div>
);

const lineVariant = {
  hidden: { y: "115%" },
  visible: { y: "0%", transition: { duration: 1, ease: EASE } },
};

export const MaskedLines = ({ lines, as = "h2", className, delay = 0, ...rest }) => {
  const MotionTag = motion[as] || motion.h2;
  return (
    <MotionTag
      className={className}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-80px" }}
      variants={{ visible: { transition: { staggerChildren: 0.12, delayChildren: delay } } }}
      {...rest}
    >
      {lines.map((line, i) => (
        <span className="mask-line" key={i}>
          <motion.span className="mask-line-inner" variants={lineVariant}>
            {line}
          </motion.span>
        </span>
      ))}
    </MotionTag>
  );
};

export { EASE };
